import React from 'react'
import ListItem from '@material-ui/core/ListItem';

export default function ZListItem(props) {
    return (
        <ListItem {...props}>
            {props.children}
        </ListItem>
    )
}
